// extracted by mini-css-extract-plugin
module.exports = {"nav":"style__nav__irWY2","item":"style__item__5ZqsG","disabled":"style__disabled__tgruV","active":"style__active__nQ+64"};